<template>
  <main>
    <div class="invitation" :class="[is_offline ? 'offline' : '']">
      <div class="page-container">
        <div class="kv" :class="{'offline-kv': is_offline && !cityCode}" :style="kvStyle">
        </div>
        <div class="content-wrap">
          <div class="content">
            <div class="gift-content">
              <img class="gift" src="@/assets/image/2026/edm-bj-xianshang.png" alt="" />
            </div>
             <img class="agenda-img" style="margin-top: 25px;" src="@/assets/image/2026/edm-agenda.png" alt=""/>
            <div class="btn-box">
              <img src="@/assets/image/2026/edm-btn.png" alt="">
              <div class="btn-wrap">
                <div class="cen">
                  <img class="btn" v-if="!user_info.id" src="@/assets/image/2024/yqhbtn01.png" alt="" @click="toRegister">
                  <img class="btn" v-else src="@/assets/image/2024/yqhbtn02.png" alt="">
                </div>
              </div>
            </div>
            <img class="logo-img" style="margin-top: 40px; width: auto;" src="@/assets/image/2026/edm-sponsor-logo.png" alt=""/>
          </div>
        </div>
      </div>
    </div>
    <div class="book-success" v-if="book_success">
      <div class="mark"></div>
      <div class="content">
        <div class="close" @click="book_success = false"></div>
        <div class="middle">
          <div class="title">您已报名成功</div>
          <div class="btn" @click="util.toLink('/')">确定</div>
        </div>
      </div>
    </div>
    <div class="epidemic-tip" v-if="show_epidemic">
      <div class="mark"></div>
      <div class="content">
        <div class="close" @click="show_epidemic = false"></div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "invitation",
  data() {
    return {
      query: "",
      book_success: false,
      show_epidemic: true,
    };
  },
  components: {},
  computed: {
    user_info() {
      // if(this.$store.state.user_info.id){
      //     this.util.toLink('/');
      // }
      return this.$store.state.user_info;
    },
    is_offline() {
      return this.util.isOffline();
    },
    channel() {
      return this.tool.storage.getLocal("channel") || "";
    },
    cityCode() {
      var channel = this.channel || "";
      if (channel.indexOf('bj-offline') !== -1) return 'bj';
      if (channel.indexOf('gz-offline') !== -1) return 'gz';
      if (channel.indexOf('qd-offline') !== -1) return 'qd';
      return '';
    },
    kvStyle() {
      if (!this.is_offline || !this.cityCode) return {};
      var img = require('@/assets/image/2026/edm-banner-xianxia-' + this.cityCode + '.png');
      return {
        backgroundImage: 'url(' + img + ')'
      };
    }
  },
  methods: {
    static(src) {
      // return require('@/assets/edm/pc/'+(this.is_offline ? '' : 'online/')+src);
      return require("@/assets/edm/pc/" + src);
    },
    toRegister() {
      // var channel = this.tool.other.getUrlParams('channel') || '';
      // var url = window.location.origin+"?params";
      // if(channel){
      //     url = url + "&channel="+channel;
      // }
      // url = url+"#/registration";
      // window.location.href = url;
      this.$router.push("/registration");
    },
    checkChannel() {
      var channel = this.tool.storage.getLocal("channel");
      if (channel == "sales-internal") {
        if (this.util.isOffline()) {
          window.location.href = "http://s-event.cn/EDM/dell/211110/belowTheLine.html";
        } else {
          window.location.href = "http://s-event.cn/EDM/dell/211110/onLine.html";
        }
      }
    }
  },
  mounted() {
    this.checkChannel();
    this.query = this.$route.query;
    if (this.user_info.id && this.tool.storage.getCookie("edm_login_tip") != 1) {
      //this.book_success = true;
      this.tool.storage.setCookie("edm_login_tip", 1, 365 * 10);
    }
    document.title = "大会信息丨2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网";
  }
};
</script>

<style lang="scss" type="text/scss" scoped>
.invitation {
  background-color: #1a56c6;

  .page-container {
    min-width: 903px;
  }

  .kv{height:300px;background: url("~@/assets/image/2026/edm-banner.png") no-repeat top center;background-size: auto 100%;}
  .offline-kv{background: url("~@/assets/image/2026/edm-banner-xianxia.png") no-repeat top center;background-size: auto 100%;}

  .content-wrap {
    padding: 40px 0 0 0;
    background-image: url("~@/assets/image/2026/edm-bj.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .content {
    width: 903px;
    display: block;
    margin: 0 auto;
    padding-bottom: 85px;
  }

  .content img {
    width: 100%;
    display: block;
    pointer-events: none;
  }

  .content .btn-box {
    position: relative
  }

  .content .btn-box {
    position: relative;
    margin-top: 25px;

    .btn-wrap {
      position: absolute;
      top: 50%;
      right: 20.5%;
      width: 18%;
      transform: translate(0, -50%);

      .cen {
        width: 100%;
        display: inline-block;

        img {
          pointer-events: auto;
        }

        .btn {
          width: 100%;
          float: left;
          cursor: pointer;
        }

        .btn:nth-last-child(1) {
          margin-right: 0;
        }
      }
    }
  }

  .logo {
    display: block;
    margin: 40px auto;
  }

  .gift-content {
    position: relative;

    .btn {
      width: 144px;
      height: 52px;
      background: url("~@/assets/edm/pc/btn.png") no-repeat center center;
      background-size: contain;
      position: absolute;
      bottom: 0;
      transform: translateY(-40%);
      left: 55%;
      cursor: pointer;
    }

    .btn.hidden {
      background-image: url("~@/assets/edm/pc/btn_2.png");
      background-size: contain;
    }
  }
}

.book-success {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  .mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .8);
  }

  .content {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 750px;
    height: 390px;
    background: url("~@/assets/image/2025/bg-success.png") no-repeat center center;
    background-size: cover;
    color: #fff;
    margin-left: -375px;
    margin-top: -195px;
    border-radius: 10px;

    .close {
      width: 50px;
      height: 50px;
      position: absolute;
      top: 0;
      right: 0;
      background: url("~@/assets/image/54.png") no-repeat center center;
      background-size: 20px;
      cursor: pointer;
      transition: background .3s ease;
    }

    .close:hover {
      background-image: url("~@/assets/image/53.png");
      background-size: 20px;
      transition: background .3s ease;
    }

    .middle {
      width: 750px;
      height: 390px;
      text-align: center;
      color: #232846;

      .title {
        font-size: 43px;
      }

      .m-title {
        font-size: 30px;
        margin-top: 30px;
        line-height: 46px;
      }

      .btn {
        width: 140px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #fff;
        margin: 80px auto 0;
        cursor: pointer;
        border-radius: 5px;
        background: #ec6014
      }
    }
  }
}

.epidemic-tip {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: none;

  .mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7)
  }

  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 740px;
    height: 549px;
    background: url("~@/assets/edm/in1.jpg") no-repeat center center;
    background-size: contain;

    .close {
      position: absolute;
      top: 0;
      right: 0;
      width: 60px;
      height: 60px;
      background: url("~@/assets/edm/close.png") no-repeat center center;
      background-size: 30px;
      cursor: pointer;
    }
  }
}
</style>

